import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import {
  Box,
  Button,
  CircularProgress,
  Typography,
} from '@mui/material';
import { addDays, addMonths, startOfMonth } from 'date-fns';
import { useMemo, useState } from 'react';
import { Header } from '../../components/header';
import { Page } from '../../components/page';
import { useGetClothingOrdersQuery } from '../../core/redux/webshop';
import { format, formatISODate } from '../../core/helpers/dates';
import { ClothingOrderItem } from '../ordersPage/partials/clothingOrderItem';
import './style.scss';
import { Order } from '../../core/types/order';

const nextWednesday = (date: Date) => {
  let res = date;
  while (res.getDay() !== 3) res = addDays(res, 1);
  return res;
};

const initialPeriod = () => {
  const today = new Date();

  const firstWednesday = today.getDate() > 7
    ? nextWednesday(addMonths(startOfMonth(today), 1))
    : nextWednesday(startOfMonth(today));

  const start = addDays(addMonths(startOfMonth(firstWednesday), -2), 24);
  const end = addDays(addMonths(startOfMonth(firstWednesday), -1), 23);

  return { start, end };
};

const AdminsOrdersPage = () => {
  const [period, setPeriod] = useState(initialPeriod());

  const { data, isLoading } = useGetClothingOrdersQuery({
    start: formatISODate(period.start),
    end: formatISODate(period.end),
  });

  const daysOrders = useMemo(() => {
    const map = new Map<string, Order[]>();
    data?.forEach((order) => {
      const day = format(order.createdTimestamp, 'EEEE do MMM yyyy');
      if (map.has(day)) {
        map.set(day, [...(map.get(day) as Order[]), order]);
      } else {
        map.set(day, [order]);
      }
    });
    return map;
  }, [data]);

  const handleNext = () => {
    setPeriod((prev) => ({
      start: addMonths(prev.start, 1),
      end: addMonths(prev.end, 1),
    }));
  };

  const handlePrevious = () => {
    setPeriod((prev) => ({
      start: addMonths(prev.start, -1),
      end: addMonths(prev.end, -1),
    }));
  };

  return (
    <Page className="orders-page">
      <Box display="flex" flexDirection="column" flex={1} alignItems="center" gap={4}>
        <Header showBack>Bestillingsliste</Header>
        <Box display="flex" alignItems="center" justifyContent="center" gap={4}>
          <Button variant="contained" onClick={handlePrevious}>
            <ChevronLeftIcon />
          </Button>
          <Typography>
            {format(period.start, 'yyyy.MM.dd')} - {format(period.end, 'yyyy.MM.dd')}
          </Typography>
          <Button
            variant="contained"
            onClick={handleNext}
            disabled={period.end.getMonth() === initialPeriod().end.getMonth() + 1}
          >
            <ChevronRightIcon />
          </Button>
        </Box>
        {isLoading && (
          <Box display="flex" flex={1} justifyContent="center" alignItems="center">
            <CircularProgress />
          </Box>
        )}
        <Box display="flex" flexDirection="column" width="800px" gap={2}>
          {daysOrders && Array.from(daysOrders.entries()).map(([day, orders]) => (
            <Box display="flex" flexDirection="column" gap={2} key={day}>
              <div className="day-header mt20 mb20">{day}</div>
              {orders.map((order: Order) => (
                <ClothingOrderItem order={order} titleVariant="Mobile Number" key={order.uid} />
              ))}
            </Box>
          ))}
        </Box>
      </Box>
    </Page>
  );
};

export default AdminsOrdersPage;
